import { CheckCircle, Headphones, Phone } from "lucide-react";
import { useState } from "react";

export const TestConnectionStep: React.FC<{
  selectedNumber: string;
  onContinue: () => void;
  onBack: () => void;
}> = ({ selectedNumber, onContinue, onBack }) => {
  const [testCalled, setTestCalled] = useState(false);

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8 max-w-2xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Test Your Connection</h2>
      <p className="text-gray-600 mb-6">
        Make a test call to verify your voice channel is working correctly.
      </p>

      <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 mb-6">
        <div className="flex items-center mb-2">
          <Headphones className="w-6 h-6 text-blue-600 mr-2" />
          <span className="font-semibold text-blue-900">Test Call Ready</span>
        </div>
        <p className="text-sm text-blue-800">Your number: {selectedNumber}</p>
      </div>

      <button
        onClick={() => setTestCalled(true)}
        className="w-full py-4 bg-blue-600 text-white rounded-lg hover:bg-blue-700 font-medium flex items-center justify-center mb-6"
      >
        <Phone className="w-5 h-5 mr-2" />
        Make Test Call
      </button>

      <div className="bg-gray-50 rounded-lg p-6 mb-6">
        <h3 className="font-medium mb-3">What to expect:</h3>
        <div className="space-y-2">
          <div className="flex items-start">
            <CheckCircle className="w-5 h-5 text-green-500 mr-2 mt-0.5" />
            <span className="text-sm text-gray-700">
              You'll receive a call from our test number
            </span>
          </div>
          <div className="flex items-start">
            <CheckCircle className="w-5 h-5 text-green-500 mr-2 mt-0.5" />
            <span className="text-sm text-gray-700">
              Follow the voice prompts to complete the test
            </span>
          </div>
          <div className="flex items-start">
            <CheckCircle className="w-5 h-5 text-green-500 mr-2 mt-0.5" />
            <span className="text-sm text-gray-700">
              We'll verify your webhook is receiving events
            </span>
          </div>
        </div>
      </div>

      <div className="flex justify-between">
        <button
          onClick={onBack}
          className="px-6 py-2 text-gray-600 hover:text-gray-800"
        >
          Back
        </button>
        <button
          onClick={onContinue}
          className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center"
        >
          Continue
          <span className="ml-2">→</span>
        </button>
      </div>
    </div>
  );
};